import { createApi } from "@reduxjs/toolkit/query/react";
import { ENDPOINTS } from "config/constant/endpoints.config";
import { Paginator } from "types/interfaces";
import { injectParamsPaginator } from "utils/helpers/api-url";
import { baseQueryWithReauth } from "../rtkBaseQuery";

export const statisticsPromotionCodeApi = createApi({
  reducerPath: "statisticsPromotionCodeApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["StatisticPromotionCode"],
  endpoints: (builder) => ({
    getPromotionCodeStatistics: builder.mutation({
      query: ({
        start_date,
        end_date
      }: {start_date?:number,end_date?:number}) => ({
        url: `/stats/codes`,
        method: "POST",
        body:start_date && end_date? {  start_date,
            end_date,
           }:{},
      }),
      invalidatesTags: ["StatisticPromotionCode"],
    }),
    getAllPromotionCodeStatistics: builder.mutation({
        query: ({
          start_date,
          end_date
        }: {start_date?:number,end_date?:number}) => ({
          url: `/stats/allcodes`,
          method: "POST",
          body:start_date && end_date? {  start_date,
              end_date,
             }:{},
        }),
        invalidatesTags: ["StatisticPromotionCode"],
      }),
  })
})

export const { useGetAllPromotionCodeStatisticsMutation,useGetPromotionCodeStatisticsMutation} =statisticsPromotionCodeApi;
